import type { ComponentProps } from 'react';

import { cn } from '../cn';
import { buttonHPadding } from '../common';
import { ButtonPropsSizeType } from '../common.type';

type InputValueProps = Omit<ComponentProps<'input'>, 'size'> & {
  size?: ButtonPropsSizeType;
  type?: ComponentProps<'input'>['type'];
  error?: string;
};

export default function InputValue({
  className,
  value,
  defaultValue,
  error,
  size,
  type,
  ref,
  ...props
}: InputValueProps) {
  const _value = value ?? (props.onChange ? '' : undefined);

  return (
    <input
      ref={ref}
      size={1}
      type={type}
      className={cn(
        'h-full shrink grow bg-transparent outline-none truncate',
        buttonHPadding(size),
        type === 'color'
          ? 'cursor-pointer p-0 first:pl-0 last:pr-0 [&::-webkit-color-swatch-wrapper]:p-0 [&::-webkit-color-swatch]:border-0'
          : undefined,
        { 'placeholder-fair-pink-600/20 dark:placeholder-fair-pink-600/20': error },
        className,
      )}
      value={_value}
      defaultValue={_value == null ? defaultValue : undefined}
      {...props}
    />
  );
}
